import React, { Component } from 'react';

import InlineEditOccupation from './Occupation/Occupation';

class Occupation extends Component {
  render() {
    return (
      <div>
        <h3>Occupation</h3>
        <div className="static-field-container">
          <InlineEditOccupation  {...this.props.occupation} {...this.props} />
        </div>
      </div>);
  }
}

export default Occupation;


// WEBPACK FOOTER //
// ./src/containers/Review/InlineEdit/Occupation.js